import axios from 'axios'
import * as types from '../mutation-types'

const doToArrayObject = datos => {
  let term = []
  let key = 0
  for (key in datos) {
    if (datos.hasOwnProperty(key)) {
      term.push({
        value: datos[key].id,
        text: datos[key].name,
      })
    }
  }

  return term
}

const doToArrayObjectByNameId = datos => {
  let term = []
  let key = 0
  for (key in datos) {
    if (datos.hasOwnProperty(key)) {
      term.push({
        value: datos[key].name_id,
        text: datos[key].name,
      })
    }
  }

  return term
}

// state
export const state = {
  loading: true,
  salesDocumentStatus: [],
  error: null,
  loadingByNameId: true,
  salesDocumentStatusByNameId: [],
  errorByNameId: null,
}

// mutations
export const mutations = {
  [types.GET_SALES_DOCUMENT_STATUS_START] (state) {
    state.loading = true
    state.salesDocumentStatus = []
    state.error = null
  },

  [types.GET_SALES_DOCUMENT_STATUS_SUCCESS] (state, { data }) {
    state.loading = false
    state.salesDocumentStatus = doToArrayObject(data)
    state.error = null
  },

  [types.GET_SALES_DOCUMENT_STATUS_ERROR] (state, { error }) {
    state.loading = false
    state.salesDocumentStatus = []
    state.error = error
  },

  [types.GET_SALES_DOCUMENT_STATUS_BY_NAME_ID_START] (state) {
    state.loadingByNameId = true
    state.salesDocumentStatusByNameId = []
    state.errorByNameId = null
  },

  [types.GET_SALES_DOCUMENT_STATUS_BY_NAME_ID_SUCCESS] (state, { data }) {
    state.loadingByNameId = false
    state.salesDocumentStatusByNameId = doToArrayObjectByNameId(data)
    state.errorByNameId = null
  },

  [types.GET_SALES_DOCUMENT_STATUS_BY_NAME_ID_ERROR] (state, { error }) {
    state.loadingByNameId = false
    state.salesDocumentStatusByNameId = []
    state.errorByNameId = error
  },
}

export const actions = {
  async getSalesDocumentStatus ({ commit }) {
    try {
      commit(types.GET_SALES_DOCUMENT_STATUS_START)
      const { data } = await axios.get('/api/sale/document_status/list?order_type=asc')

      commit(types.GET_SALES_DOCUMENT_STATUS_SUCCESS, { data })
    } catch (e) {
      commit(types.GET_SALES_DOCUMENT_STATUS_ERROR, { error: e })
    }
  },

  async getSalesDocumentStatusByNameId ({ commit }) {
    try {
      commit(types.GET_SALES_DOCUMENT_STATUS_BY_NAME_ID_START)
      const { data } = await axios.get('/api/sale/document_status/list?order_type=asc')

      commit(types.GET_SALES_DOCUMENT_STATUS_BY_NAME_ID_SUCCESS, { data })
    } catch (e) {
      commit(types.GET_SALES_DOCUMENT_STATUS_BY_NAME_ID_ERROR, { error: e })
    }
  },
}

// getters
export const getters = {
  loadingSalesDocumentStatus: state => state.loading,
  salesDocumentStatus: state => state.salesDocumentStatus,
  errorSalesDocumentStatus: state => state.error,
  loadingSalesDocumentStatusByNameId: state => state.loadingByNameId,
  salesDocumentStatusByNameId: state => state.salesDocumentStatusByNameId,
  errorSalesDocumentStatusByNameId: state => state.errorByNameId,
}
